import React from 'react'
import { VestingList } from '../../components/vesting/vesting-list'
import { useWallet } from '@solana/wallet-adapter-react'

export default function VestingPage() {
  const { publicKey } = useWallet()

  if (!publicKey) {
    return (
      <div className="bit-container">
        <div className="bit-welcome-container">
          <div className="bit-welcome-content">
            <h2 className="bit-title">Welcome to Vesting App</h2>
            <p className="bit-text">Connect your wallet to get started</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bit-container">
      <div className="space-y-4">
        <h2 className="bit-title">My Vesting Schedules</h2>
        <VestingList />
      </div>
    </div>
  )
} 